import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../services/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      await api.post('/auth/forgot-password', { email })
      setSent(true)
    } catch {
      setError(t('forgotPassword.error'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'#f8f9fa',padding:20}}>
      <div style={{backgroundColor:'#fff',borderRadius:20,padding:40,width:'100%',maxWidth:400,boxShadow:'0 4px 24px rgba(0,0,0,0.06)'}}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <img src="/favicon.svg" alt="Vigilant" style={{width:56,height:56}} />
        </div>

        {sent ? (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:48,marginBottom:12}}>📧</div>
            <h2 style={{fontSize:20,fontWeight:600,color:'#1a1a1a',margin:'0 0 8px'}}>{t('forgotPassword.title')}</h2>
            <p style={{fontSize:15,color:'#888',margin:'0 0 28px'}}>{t('forgotPassword.success')}</p>
            <button style={{padding:'12px 24px',borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:15,fontWeight:600,cursor:'pointer'}} onClick={() => navigate('/login')}>
              {t('forgotPassword.back').replace('‹ ', '')}
            </button>
          </div>
        ) : (
          <>
            <h1 style={{fontSize:24,fontWeight:600,textAlign:'center',margin:'0 0 8px',color:'#1a1a1a'}}>{t('forgotPassword.title')}</h1>
            <p style={{fontSize:14,textAlign:'center',color:'#888',margin:'0 0 28px'}}>{t('forgotPassword.subtitle')}</p>
            {error && <div style={{backgroundColor:'#fff0f0',color:'#e74c3c',padding:'12px 16px',borderRadius:10,fontSize:14,marginBottom:16}}>{error}</div>}
            <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:12}}>
              <input
                style={{padding:'14px 16px',borderRadius:12,border:'1px solid #e0e0e0',fontSize:16,outline:'none'}}
                type="email"
                placeholder={t('common.email')}
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
              <button style={{padding:14,borderRadius:12,border:'none',backgroundColor:'#2D7A3A',color:'#fff',fontSize:16,fontWeight:600,cursor:'pointer',marginTop:4}} type="submit" disabled={loading}>
                {loading ? t('forgotPassword.loading') : t('forgotPassword.submit')}
              </button>
            </form>
            <p style={{textAlign:'center',marginTop:20,margin:'20px 0 0'}}>
              <button style={{background:'none',border:'none',color:'#2D7A3A',fontSize:14,cursor:'pointer'}} onClick={() => navigate('/login')}>
                {t('forgotPassword.back')}
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  )
}
